<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'collarDetails',
    components: {
      baseEdit,
    },
  };
</script>
